import React, { useEffect, useState } from 'react';
import './style.scss';
import '../style.scss';

import { Modal } from 'antd';
import userGuide1 from "assets/imgs/QrCodeMyVNPT/user-guide-1.png";
import userGuide2 from "assets/imgs/QrCodeMyVNPT/user-guide-2.png";
import userGuide3 from "assets/imgs/QrCodeMyVNPT/user-guide-3.png";
import userGuide4 from "assets/imgs/QrCodeMyVNPT/user-guide-4.png";
import userGuide5 from "assets/imgs/QrCodeMyVNPT/user-guide-5.png";
import userGuide6 from "assets/imgs/QrCodeMyVNPT/user-guide-6.png";
import userGuide7 from "assets/imgs/QrCodeMyVNPT/user-guide-7.png";
import userGuide8 from "assets/imgs/QrCodeMyVNPT/user-guide-8.png";
import userGuide9 from "assets/imgs/QrCodeMyVNPT/user-guide-9.png";
import { DEVICE } from '../constant/contanst';

const UserGuide = ({ device, isModal, setIsModal }) => {
  const [stepGuide, setStepGuide] = useState(0);
  const [dataStep, setDataStep] = useState([]);
  
  const userGuideAPK = [
    {
      img: userGuide1,
      title: '<strong>Bước 1:</strong> Tại màn hình Thông tin giao dịch, bấm "Thanh Toán"',
    },
    {
      img: userGuide2,
      title: '<strong>Bước 2:</strong> Hệ thống đã tự động tải xuống mã QR, mở ứng dụng ngân hàng của bạn',
    },
    {
      img: userGuide3,
      title: '<strong>Bước 3:</strong> Mở tính năng “Quét mã QR” trên ứng dụng ngân hàng của bạn (VD: Vietcombank)',
    },
    {
      img: userGuide4,
      title: '<strong>Bước 4:</strong> Nhấn “Chọn QR từ thư viện ảnh”',
    },
    {
      img: userGuide5,
      title: '<strong>Bước 5:</strong> Chọn mã QR vừa được tải xuống',
    },
    {
      img: userGuide6,
      title: '<strong>Bước 6:</strong> Kiểm tra lại thông tin thanh toán và hoàn thành giao dịch',
    },
  ]

  const userGuideIOS = [
    {
      img: userGuide1,
      title: '<strong>Bước 1:</strong> Tại màn hình Thông tin giao dịch, bấm “Thanh Toán"',
    },
    {
      img: userGuide7,
      title: '<strong>Bước 2:</strong> Nhấn giữ mã QR',
    },
    {
      img: userGuide8,
      title: '<strong>Bước 3:</strong> Bấm “Lưu hình ảnh”',
    },
    {
      img: userGuide9,
      title: '<strong>Bước 4:</strong> Chọn ứng dụng ngân hàng của bạn',
    },
    {
      img: userGuide3,
      title: '<strong>Bước 5:</strong> Mở tính năng “Quét mã QR” trên ứng dụng ngân hàng',
    },
    {
      img: userGuide4,
      title: '<strong>Bước 6:</strong> Nhấn “Chọn QR từ thư viện ảnh”',
    },
    {
      img: userGuide5,
      title: '<strong>Bước 7:</strong> Chọn mã QR vừa được tải xuống',
    },
    {
      img: userGuide6,
      title: '<strong>Bước 8:</strong> Kiểm tra lại thông tin thanh toán và hoàn thành giao dịch',
    },
  ]

  const handleOpenApp = () => {
  }

  useEffect(() => {
    if (device == DEVICE.ANDROID) {
      setDataStep(userGuideAPK);
    } else if (device == DEVICE.IOS) {
      setDataStep(userGuideIOS);
    } else {
      setDataStep([]);
    }
    setStepGuide(0);
  }, [device, isModal]);
  
  const nextStep = () => {
    if (stepGuide < dataStep?.length - 1) {
      setStepGuide(stepGuide + 1);
    } else {
      setIsModal(false);
    }
  };

  return (
    <Modal
      className="qr-code__modal-custom"
      title={null}
      footer={null}
      open={isModal}
      onCancel={() => setIsModal(false)}
    >
      <div className="qr-code-modal-user-guide">
        <div className="modal-user-guide-title">Hướng dẫn thanh toán</div>
        <div className="modal-user-guide-step">
          <img src={dataStep[stepGuide]?.img} alt="" />
          <div
            className="user-guide-step-title"
            dangerouslySetInnerHTML={{
              __html: dataStep[stepGuide]?.title,
            }}
          />
        </div>
        <button
          className="qr-code__btn-custom user-guide-btn-next"
          onClick={nextStep}
        >
          {stepGuide === dataStep.length - 1 ? "Hoàn tất" : "Tiếp tục"}
        </button>
      </div>
    </Modal>
  );
}

export default React.memo(UserGuide);
